export default __webpack_public_path__ + "static/media/arrow-down.000e459c.svg";